document.addEventListener("click", (e) => {
  const openBtn = e.target.closest("[data-open-modal]");
  const closeBtn = e.target.closest("[data-close-modal]");

  if (openBtn) {
    const id = openBtn.getAttribute("data-open-modal");
    const dialog = document.getElementById(id);
    if (dialog && typeof dialog.showModal === "function") dialog.showModal();
  }

  if (closeBtn) {
    const dialog = closeBtn.closest("dialog");
    if (dialog && typeof dialog.close === "function") dialog.close();
  }
});

// Close when clicking the backdrop area (outside the inner content)
document.addEventListener("click", (e) => {
  const dialog = e.target instanceof HTMLElement ? e.target.closest("dialog.specs-modal") : null;
  if (!dialog) return;

  // If the click is directly on the dialog (not inside .specs-modal__inner), treat it as backdrop click
  const inner = dialog.querySelector(".specs-modal__inner");
  if (inner && e.target === dialog) dialog.close();
});
